import { DefaultSchema } from "../default-schema"
import { TipoUsuario } from "./tipo-usuario"
import { z } from 'zod'
import { v7 } from 'uuid'

export const SchemaUsuario = DefaultSchema.extend({
    id: z.uuidv7().default(() => v7()),
    nome: z.string().default(''),
    login: z.string().default(''),
    senha: z.optional(z.string()),
    tipo: z.enum(TipoUsuario).default(TipoUsuario.AUXILIAR_DE_ESTOQUE)
})